export default __webpack_public_path__ + "static/media/home_connect_pc.517b9783.svg";